import Box, { BoxProps } from '@mui/material/Box';

export { Box, BoxProps };
